/*
 * @file: 监听点击事件发送点位
 * @author: xuyong08
 */
import {send} from '@utils/ubcLogger/send';

function clickLogHandle(this: HTMLElement) {
    const clickElement = this;
    if (clickElement?.dataset?.log) {
        try {
            const params = JSON.parse(clickElement.dataset.log);
            const {value = '', ext = {}} = params || {};
            send({
                type: 'clk',
                value,
                ext
            });
        } catch (e) {
            console.error(e);
        }
    }
}

export const loggerClick = () => {
    const remove = (target: HTMLElement) => {
        target.removeEventListener('click', clickLogHandle, false);
    };

    const add = (target: HTMLElement) => {
        remove(target);
        target.addEventListener('click', clickLogHandle, false);
    };

    return {
        add,
        remove
    };
};
